import { loadSummarySheetData } from '@/api/report';
import { timeFormat } from '@/utils/other';
import {
  changeCreatorOption,
  changeOwnerOption,
  changeQuotationCategoryOption,
  changeSettlementUnitOptionByArray,
  changeStatusOption,
} from './uitls';

type ISummarySheetClass = IReport.ISummarySheet.ISummarySheetClass;
type IDataInfo = IReport.ISummarySheet.IDataInfo;
type IRequestSummarySheetParams = IReport.ISummarySheet.IRequestSummarySheetParams;
type IOptionInfo = IReport.IOptionInfo;

const generateId = (row: IDataInfo) => row.moduleId.slice(0, 5) + row.owner.slice(0, 5);

class SummarySheetClass implements ISummarySheetClass {
  private $data: IDataInfo[] = [];
  get data() {
    return this.$data;
  }
  public requestData(params: IRequestSummarySheetParams): Promise<string> {
    return new Promise((reslove, reject) => {
      loadSummarySheetData(params).then((res) => {
        this.$updateData(res.data);
        if (res.data.length > 0) {
          reslove(res.message);
        } else {
          reject('暂无数据');
        }
      }).catch((error) => {
        reject(error.message);
      });
    });
  }
  public clearData() {
    this.$data = [];
  }
  private $updateData(data: IDataInfo[]) {
    data.sort((a, b) => new Date(a.settlementDate).valueOf() - new Date(b.settlementDate).valueOf());
    this.$data = data.map((item) => {
      item.settlementDate = item.settlementDate ? timeFormat(item.settlementDate, 'YYYY-MM-DD') : '';
      item.id = generateId(item);
      return item;
    });
  }
}

export const generateOptions = (reportData: IDataInfo[]): IReport.ISummarySheet.IFilterOption => {
  const ownerOption: IOptionInfo[] = [];
  const statusOption: IOptionInfo[] = [];
  const creatorOption: IOptionInfo[] = [];
  const settlementUnitOption: IOptionInfo[] = [];
  const quotationCategoryOption: IOptionInfo[] = [];
  const ownerIds: string[] = [];
  const statusTxts: string[] = [];
  const createIds: string[] = [];
  const quotationCategoryTxts: string[] = [];
  const settlementUnitTxts: string[] = [];
  reportData.forEach((item) => {
    changeOwnerOption(item, ownerIds, ownerOption);
    changeStatusOption(item, statusTxts, statusOption);
    changeCreatorOption(item, createIds, creatorOption);
    changeSettlementUnitOptionByArray(item, settlementUnitTxts, settlementUnitOption);
    changeQuotationCategoryOption(item, quotationCategoryTxts, quotationCategoryOption);
  });
  return {
    ownerOption,
    statusOption,
    creatorOption,
    settlementUnitOption,
    quotationCategoryOption,
  };
};

export const summarySheetInstance = new SummarySheetClass();
